"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _BundleCard = _interopRequireDefault(require("./BundleCard"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _CovidSelectors = require("../../../selectors/CovidSelectors");

var _PromotionSelectors = require("../../../selectors/PromotionSelectors");

var _itemConfigUtils = require("../../../utils/itemConfigUtils");

var _Terms = require("self-service-api/constants/Terms");

var _Editions = require("self-service-api/constants/Editions");

var _MarketingContactsSelectors = require("../../../selectors/MarketingContactsSelectors");

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _PricingSelectors = require("../../../selectors/PricingSelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _CurrencySelectors = require("../../../selectors/CurrencySelectors");

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _SuiteTileCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteTileCTAsContainer"));

var _SuiteViewAllFeatures = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteViewAllFeatures"));

var _SuiteCovidPromoBanner = _interopRequireDefault(require("../../growth-suite-page/SuiteCovidPromoBanner"));

var _urls = require("../../../utils/urls");

var _Tracking = require("../../../constants/Tracking");

var StarterGrowthSuiteCard = function StarterGrowthSuiteCard() {
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var isCovidPromo = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector);
  var availableTerms = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, isCovidPromo);
  });
  var calculateBundlePrice = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculateBundlePriceSelector);
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  if (!hasPricingAndPurchasingSucceeded) return null; // TODO

  var starterSuiteMerchIds = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[_Editions.STARTER];

  var pricingParams = {
    bundleSelections: {
      marketingPlanSelected: starterSuiteMerchIds[Hubs.HUB_MARKETING],
      salesPlanSelected: starterSuiteMerchIds[Hubs.HUB_SALES],
      servicePlanSelected: starterSuiteMerchIds[Hubs.HUB_SERVICE]
    },
    term: (0, _itemConfigUtils.getApplicableTerm)(_Terms.MONTHLY, availableTerms[_Editions.STARTER]),
    isGrowthSuite: true
  };
  var pricingInfo = calculateBundlePrice(Object.assign({}, pricingParams, {
    isCovidPromo: isCovidPromo
  }));
  var noCovidPromoPricingInfo = calculateBundlePrice(pricingParams);
  return _react.default.createElement(_BundleCard.default, {
    banner: isCovidPromo && _react.default.createElement(_SuiteCovidPromoBanner.default, {
      toPrice: pricingInfo.monthly.calculatedPrice,
      fromPrice: noCovidPromoPricingInfo.monthly.calculatedPrice,
      currencyCode: currencyCode,
      xPadding: 40
    }),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.growthSuite.title.starter"
    }),
    descriptionSubtext: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_FormattedMessage.default, {
      message: "recommendedBundles.growthSuite.description"
    }), ' ', _react.default.createElement(_UILink.default, {
      href: (0, _urls.getSuiteLegalDisclaimerUrl)(),
      external: true
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.growthSuite.details"
    }))),
    listPrice: noCovidPromoPricingInfo.monthly.calculatedPrice,
    costPrice: pricingInfo.monthly.calculatedPrice,
    currencyCode: currencyCode,
    ctasComponent: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_SuiteTileCTAsContainer.default, {
      edition: _Editions.STARTER,
      isCovidPromo: isCovidPromo,
      trackingSource: _Tracking.BUNDLE_CARD
    }), _react.default.createElement("div", {
      className: "m-top-3"
    }, _react.default.createElement(_SuiteViewAllFeatures.default, {
      edition: _Editions.STARTER,
      currencyCode: currencyCode
    }))),
    bizObjectives: ['recommendedBundles.growthSuite.businessObjectives.captureAndConvert', 'recommendedBundles.growthSuite.businessObjectives.organizeYourTeam', 'recommendedBundles.growthSuite.businessObjectives.organizeComms'],
    includedMerch: [{
      iconSrc: _ProductPageIcons.default['crm'],
      message: 'pricingPage.pages.growthSuite.crm'
    }, {
      iconSrc: _ProductPageIcons.default['marketing'],
      message: 'pricingPage.pages.growthSuite.marketing.starter'
    }, {
      iconSrc: _ProductPageIcons.default['sales'],
      message: 'pricingPage.pages.growthSuite.sales.starter'
    }, {
      iconSrc: _ProductPageIcons.default['service'],
      message: 'pricingPage.pages.growthSuite.service.starter'
    }]
  });
};

var _default = StarterGrowthSuiteCard;
exports.default = _default;
module.exports = exports.default;